export type ResetModalType = "secretCode" | "password";

interface Modal {
  isOpen: boolean;
}
interface PrescriptionCompletedModal extends Modal {
  prescriptionId: string | null;
}
interface ResetModal extends Modal {
  type: ResetModalType | null;
}
interface SecretCodeModal extends Modal {
  title: string | null;
  name: string | null;
  secretCode: string | null;
}

interface ConfirmUsedCodeModal extends Modal {
  supportUrl: string;
}

interface ExtendPrescriptionCodeExpiryCompletedModal extends Modal {
  name: string;
  expiry: string | null;
}

export type Modals = {
  createPrescription: Modal;
  cancelCreatePrescription: Modal;
  editPrescription: Modal;
  cancelEditPrescription: Modal;
  deletePrescription: Modal;
  sessionExpired: Modal;
  prescriptionCompleted: PrescriptionCompletedModal;
  createMember: Modal;
  cancelCreateMember: Modal;
  editMember: Modal;
  cancelEditMember: Modal;
  suspendMember: Modal;
  secretCode: SecretCodeModal;
  reset: ResetModal;
  editPrescriptionItems: Modal;
  cancelEditPrescriptionItems: Modal;
  editMedicalInstitution: Modal;
  cancelEditMedicalInstitution: Modal;
  extendPrescriptionCodeExpiry: Modal;
  extendPrescriptionCodeExpiryCompleted: ExtendPrescriptionCodeExpiryCompletedModal;
  error: Modal;
  faqAndHelp: Modal;
  confirmUsedCode: ConfirmUsedCodeModal;
  confirmInput: Modal;
  confirmVerifyCode: Modal;
};
export type AdditionArgsRequierdModalsName =
  | "prescriptionCompleted"
  | "secretCode"
  | "reset";

const defaultModal = {
  isOpen: false,
};

export const initialState: Modals = {
  createPrescription: { ...defaultModal },
  cancelCreatePrescription: { ...defaultModal },
  editPrescription: { ...defaultModal },
  cancelEditPrescription: { ...defaultModal },
  deletePrescription: { ...defaultModal },
  sessionExpired: { ...defaultModal },
  prescriptionCompleted: {
    ...defaultModal,
    prescriptionId: null,
  },
  createMember: { ...defaultModal },
  cancelCreateMember: { ...defaultModal },
  editMember: { ...defaultModal },
  cancelEditMember: { ...defaultModal },
  suspendMember: { ...defaultModal },
  secretCode: {
    isOpen: false,
    title: null,
    name: null,
    secretCode: null,
  },
  reset: {
    type: null,
    ...defaultModal,
  },
  editPrescriptionItems: { ...defaultModal },
  cancelEditPrescriptionItems: { ...defaultModal },
  editMedicalInstitution: { ...defaultModal },
  cancelEditMedicalInstitution: { ...defaultModal },
  extendPrescriptionCodeExpiry: { ...defaultModal },
  extendPrescriptionCodeExpiryCompleted: {
    ...defaultModal,
    name: "",
    expiry: null,
  },
  error: { ...defaultModal },
  faqAndHelp: { ...defaultModal },
  confirmUsedCode: { ...defaultModal, supportUrl: "" },
  confirmInput: { ...defaultModal },
  confirmVerifyCode: { ...defaultModal },
};
